import { Component, ElementRef, ViewChild, OnDestroy, AfterViewInit } from '@angular/core';
import { TourStep } from '../tour-guide/tour-guide.component';
import { GuidedTourService } from 'src/app/shared/services/guided-tour.service';

@Component({
  selector: 'app-data-products',
  templateUrl: './data-products.component.html',
  styleUrl: './data-products.component.scss'
})
export class DataProductsComponent implements AfterViewInit, OnDestroy {
  @ViewChild('overlay') overlayRef!: ElementRef;
  showTour = false;

  tourSteps: TourStep[] = [
    // {
    //   topic: 'Improved Navigation',
    //   selector: 'a.nav-item.nav-link.active',
    //   description: 'The ‘Data Manager’ and ‘Capabilities’ sections have been merged into a single entity known as ‘Data Products’, thereby enhancing the overall user experience.'
    // },
    // {
    //   topic: 'Updated Labels',
    //   selector: '.contentCard .tabSelectorCont',
    //   description: 'Capabilities is now ‘Data Products’ and ‘Data Manager’ is now ‘My Reports’ to better reflect their purpose.'
    // },
    // {
    //   topic: 'Product Card',
    //   selector: '.productsGrid .productCard:first-child',
    //   description: 'We\'ve added a detailed product page to give you more insights and context for better understanding and decision-making.'
    // }
  ];

  private showTourSub: any;
  constructor(public tourService: GuidedTourService) {
    this.showTourSub = this.tourService.showTour$.subscribe(show => {
      if (show) {
      //  document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    });
  }
  ngOnDestroy() {
    if (this.showTourSub && typeof this.showTourSub.unsubscribe === 'function') {
      this.showTourSub.unsubscribe();
      document.body.style.overflow = '';
    }
  }
  ngOnInit() {
     window.scrollTo({ top: 0, behavior: 'auto' });
  }
  ngAfterViewInit() {
    window.addEventListener('load', () => {
      setTimeout(() => {
    //    this.startTour();
      }, 3000);
    });
  }

  startTour() {
 //   this.tourService.startTour();
      this.tourService.showTourOnTabChange$?.next?.(true);
  }

}
